import { FC } from 'react'
import { ContainerBigger } from '../../components/container'
import { MenuItem } from './menu_item'
import { texts } from '../../components/locale'
import { MenuLine, MenuWrapper } from './styled'

const MENU_ITEMS = [
  {
    title: texts.menu_1,
    subtitle: texts.menu_2,
    backgroundAnimation: [0, 40], // [start position, end position], in percent
    background:
      'https://gdb.rferl.org/4F79F2EA-D84C-417B-BEDC-27347A9B0CB4_w1920_r4.jpg',
  },
  {
    title: texts.menu_3,
    subtitle: texts.menu_4,
    background:
      'https://gdb.rferl.org/0B66CB59-AE3E-4AB7-9130-ACA9E4AE9CE0_w1920_r4.jpg',
  },
  {
    title: texts.menu_5,
    subtitle: texts.menu_6,
    backgroundAnimation: [20, 60],
    background:
      'https://gdb.rferl.org/812AB8D4-4B52-4CEE-854D-F3C3D85BB221_w1920_r4.jpg',
  },
  {
    title: texts.menu_7,
    subtitle: texts.menu_8,
    background:
      'https://gdb.rferl.org/01000000-0a00-0242-ba77-08dc11179616_w1920_r4.jpg',
  },
  {
    title: texts.menu_9,
    subtitle: texts.menu_10,
    background:
      'https://gdb.rferl.org/02330000-0aff-0242-74e0-08da04becca1_w1920_r4.jpg',
  },
  {
    title: texts.menu_11,
    subtitle: texts.menu_12,
    background:
      'https://gdb.rferl.org/0D094FD6-358A-46FF-953E-348F244669DB_w1920_r4.jpg',
  },
  {
    title: texts.menu_13,
    subtitle: texts.menu_14,
    background:
      'https://gdb.rferl.org/01000000-c0a8-0242-40ae-08db4b1bd850_w1920_r4.jpg',
  },
  {
    title: texts.menu_15,
    subtitle: texts.menu_16,
    background:
      'https://gdb.rferl.org/01000000-0aff-0242-102b-08db6d048e24_w1920_r4.jpg',
  },
  {
    title: texts.menu_17,
    subtitle: texts.menu_18,
    background:
      'https://gdb.rferl.org/01000000-0aff-0242-f9a4-08db4ad2500e_w1920_r4.jpg',
  },
]

type Props = {
  handleOpenTimeline: (index: number) => void
}

export const Menu: FC<Props> = ({ handleOpenTimeline }) => {
  return (
    <ContainerBigger>
      <MenuLine />
      <MenuWrapper>
        {MENU_ITEMS.map(({ backgroundAnimation, ...item }, index) => (
          <MenuItem
            key={index}
            id={index}
            onClick={(index) => handleOpenTimeline(index)}
            backgroundAnimation={
              backgroundAnimation as [number, number] | undefined
            }
            {...item}
          ></MenuItem>
        ))}
      </MenuWrapper>
    </ContainerBigger>
  )
}
